<template>
	<div class="kr-panel">
		<header class="kr-panel-header">
			<p>{{ translate( "description" ) }}</p>
			<TeamingButton
				:size="buttonSize"
				@click="$emit( `newKeyResult` )"
			>
				{{ translate( "newKRButtonText" ) }}
			</TeamingButton>
		</header>
		<main class="kr-panel-body">
			<slot name="body"></slot>
		</main>
	</div>
</template>

<script>
import {
	TranslateMixin,
	ViewportMixin,
	TeamingButton
} from "@teaming/common-ui";

export default {
	name: "KRPanel",
	teamingPackage: "common-gokr",
	mixins: [
		TranslateMixin,
		ViewportMixin,
	],
	emits: [ "newKeyResult", ],
	components: {
		TeamingButton,
	},
};
</script>

<style lang="scss" scoped>
$krPanelTextColor: $color1-500;

.kr-panel {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 1rem;

	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	width: 100%;
}

.kr-panel .kr-panel-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;

	button {
		flex: 1;
	}

	p {
		display: none;
	}

	@include for-size('md') {
		button {
			flex: unset;
		}

		p {
			display: flex;
			color: $krPanelTextColor;
			@include font-and-line-for(-1);
			font-weight: 450;
		}
	}
}

.kr-panel-body {
	flex: 1;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;

	@include auto-y-scroll();
}
</style>
